import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ContactService } from 'src/app/_services/dispo/contact.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ImportService } from 'src/app/_services/dispo/import.service.';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-import',
  templateUrl: './import.component.html',
  styleUrls: ['./import.component.css']
})
export class ImportComponent implements OnInit {
  @ViewChild('fileInput') fileInput: ElementRef;

  calculateOnImport: boolean = false;
  customerId='';
  customerObject: any;
  content?: string;
  isNew? : Boolean;
  selectedFile: File | null = null;
  selectedTable: any;
  uploadProgress = 0;
  isUploading = false;
  allowedFileTypes = ['.csv', '.xlsx', '.xls'];
  maxFileSize = 5 * 1024 * 1024; // 5MB
  importCount: number | null = null;
  calculationCount: number | null = null;
  showStatistics: boolean = false;

  constructor(
    private route: ActivatedRoute, 
    private router: Router,
    private toastr: ToastrService,
    private importService: ImportService,
    private contactService: ContactService,
    private http: HttpClient
  ) { }

  ngOnInit(): void {
    //this.customerId = this.route.snapshot.params.id;
    /*
    this.contactService.show(this.customerId).subscribe(
      data => {
        this.customerObject = data;
        this.isNew = this.contactService.getIsNew();
      },
      err => {
        this.content = JSON.parse(err.error).message;
      }
    );
    */
  }

  showModal = false;

  ngAfterContentInit() {
    this.showModal = true;
  }

  onFileSelected(event: any): void {
    const file = event.target.files[0];
    if (file) {
      if (this.validateFile(file)) {
        this.selectedFile = file;
      }
    }
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    
    const file = event.dataTransfer?.files[0];
    if (file && this.validateFile(file)) {
      this.selectedFile = file;
    }
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
  }

  validateFile(file: File): boolean {
    // Überprüfe Dateityp
    const fileExtension = '.' + file.name.split('.').pop()?.toLowerCase();
    if (!this.allowedFileTypes.includes(fileExtension)) {
      this.toastr.error('Nur CSV und Excel Dateien sind erlaubt.');
      return false;
    }

    // Überprüfe Dateigröße
    if (file.size > this.maxFileSize) {
      this.toastr.error('Die Datei ist zu groß. Maximale Größe: 5MB');
      return false;
    }

    return true;
  }

  uploadFile(): void {
    if (!this.selectedFile) {
      this.toastr.warning('Bitte wählen Sie eine Datei aus.');
      return;
    }

    const formData = new FormData();
    formData.append('csv', this.selectedFile);
    formData.append('calculate', this.calculateOnImport.toString());

    this.isUploading = true;
    this.uploadProgress = 0;
    this.showStatistics = false;

    this.http.post(`${environment.prismaApiUrl}/api/upload`, formData, {
      reportProgress: true,
      observe: 'events'
    }).subscribe({
      next: (event: any) => {
        if (event.type === HttpEventType.UploadProgress) {
          this.uploadProgress = Math.round(100 * event.loaded / event.total);
        } else if (event.type === HttpEventType.Response) {
          this.isUploading = false;
          console.log('Response received:', event.body); // Debug-Ausgabe
          
          if (event.body && typeof event.body === 'object') {
            this.importCount = event.body.importCount || 0;
            this.calculationCount = event.body.calculationCount || 0;
            this.showStatistics = true;
            this.toastr.success(`Import erfolgreich: ${this.importCount} Aufträge importiert, ${this.calculationCount} mit Kalkulation`);
          } else {
            this.toastr.success('Datei erfolgreich importiert');
          }
          this.resetUpload();
        }
      },
      error: (error) => {
        this.isUploading = false;
        this.showStatistics = false;
        this.toastr.error('Fehler beim Import: ' + error.message);
      }
    });
  }

  resetUpload(): void {
    this.selectedFile = null;
    this.uploadProgress = 0;
    if (this.fileInput) {
      this.fileInput.nativeElement.value = '';
    }
    // Die Statistik bleibt sichtbar, wird nicht zurückgesetzt
  }

  triggerFileInput(): void {
    this.fileInput.nativeElement.click();
  }

  onSelectTable(event) {
    this.selectedTable = event.target.value;
  }

  killAll() {
    /*
    this.bioDbSpectraService.killAll().subscribe(
      data => {
        this.toastr.warning('Daten wurden gelöscht', 'Datenkill');
        this.fetchData();
      },
      err => {
        this.customerList = JSON.parse(err.error).message;
      }
    );
    */
  }
  
  goBack() {
    this.router.navigate(['../'],{ relativeTo: this.route }).then(() => {});
  }

  onDialogClick(event: UIEvent) {
    event.stopPropagation();
    event.cancelBubble = true;
  }
}